import React from 'react'
import { formatDate, defaultDateTimeFormat } from '@/utils/dateUtilities'
import Icon from '@/components/Icon'

const AdditionalDetails = ({ data, creationTime }) => {
  const renderFilename = (data) => {
    return data && data.filename && <small><Icon name='file' /> {data.filename}</small>
  }
  const renderLanguage = (data) => {
    return data && data.languagePostfix && <small>, {data.languagePostfix}</small>
  }
  return (
    <React.Fragment>
      <span className='creation-time'>
        <Icon name='time-five' />  {formatDate(creationTime, defaultDateTimeFormat)}
      </span>
      <span className='filename-and-lang'>
        {renderFilename(data)}
        {renderLanguage(data)}
      </span>
    </React.Fragment>
  )
}

export {
  AdditionalDetails
}



// WEBPACK FOOTER //
// ./src/components/backgroundJobs/additionalDetails.js